import React, { useState } from "react";
import styled from "styled-components";
import { ReactComponent as Send } from "../../../assets/img/icons/SendingWhite.svg";
import { ReactComponent as Eye } from "../../../assets/img/icons/eye.svg";
import { ReactComponent as Elipsis } from "../../../assets/img/icons/ArticlePopover/Elipsis.svg";
import { ReactComponent as Mail } from "../../../assets/img/icons/mail.svg";
import { ReactComponent as Audience } from "../../../assets/img/icons/Audience.svg";
import { ReactComponent as Click } from "../../../assets/img/icons/Click.svg";
import { ReactComponent as CampaignIcon } from "../../../assets/img/icons/Campaign/AllCampaign.svg";
import { ReactComponent as Flow } from "../../../assets/img/icons/nav/Flow.svg";

import ShareMenuPopup from "../../Common/Components/ShareMenuPopup";
import MenuPopup from "modules/Common/Components/MenuPopup";
import { Tag, Tooltip, Typography } from "antd";
import store from "store";
import { CAMPAIGNS_LIST, GET_CAMPAIGNS_NAMES_ONLY } from "constants/types";
import { cloneCampaignService } from "modules/Services/CampaignsService";

type Props = {
  campaignId?: string;
  deleteHandler?(index: any, campaignId: string, assetCount: number): void;
  index?: number;
  imgUrlOne?: string;
  imgUrlTwo?: string;
  imgUrlThree?: string;
  imgUrlFour?: string;
  audience?: string;
  send?: string;
  mail?: string;
  views?: string;
  clicks?: string;
  emailsCount?: number;
  asset?: boolean;
  active?: boolean;
  onCardClick?: () => void;
  heading?: string;
  emailType?: string;
  published?: string;
  showDeleteConfirmation?: () => void;
  automation?: boolean;
};
const CampaignList: React.FC<Props> = ({
  campaignId,
  deleteHandler,
  index,
  imgUrlOne,
  imgUrlTwo,
  imgUrlThree,
  imgUrlFour,
  audience,
  send,
  mail,
  views,
  clicks,
  asset,
  active,
  onCardClick,
  heading,
  emailType,
  published,
  emailsCount,
  showDeleteConfirmation,
  automation
}) => {
  const [ellipsisState, setEllipsisState] = useState<boolean>(false);
  const { Paragraph } = Typography;

  // disable delete for campaigns sent via plugin
  const sentViaPlugin: boolean = heading?.startsWith('Campaigns sent via Gmail |') || heading?.startsWith('Campaigns sent via Outlook |') || false

  const cloneCampaignHandler = (hide: () => void) => {
    store.dispatch({
      type: CAMPAIGNS_LIST.CLONE_IN_PROGRESS,
      payload: true,
    });
    campaignId &&
      cloneCampaignService(parseInt(campaignId))
        .then((res) => {
          const data = res.data;
          const campId = campaignId;
          if (data.success) {
            store.dispatch({
              type: CAMPAIGNS_LIST.CLONE,
              payload: { campId, data },
            });
          }
          store.dispatch({
            type: GET_CAMPAIGNS_NAMES_ONLY.SUCCESS,
            payload: [{ campaign_id: res.data.campaign_id, name: res.data.campaign_name }],
            newlyAdded: true,
          });
          hide();
        })
        .catch((err) => {
          store.dispatch({
            type: CAMPAIGNS_LIST.CLONE_IN_PROGRESS,
            payload: false,
          });
          hide();
        });
  };

  return (
    <Wrapper>
      {automation && <div style={{ position: "relative" }}>
        <div className={`wf-icon automation-icon styling-tag pending-tag`}>
          <Flow /> <span>Workflow</span>
        </div>
      </div>}
      <div
        className={`list-wrapper ${active === true ? "active" : ""}`}
        onClick={() => {
          if (onCardClick) onCardClick();
        }}
      >
        <div className="left-data">
          <div className="img-wrapper">
            <div
              className="preview-1"
              style={{
                backgroundImage: `url(
              ${imgUrlOne}
            )`,
              }}
            ></div>
            <div
              className="preview-2"
              style={{
                backgroundImage: `url(
              ${imgUrlTwo}
            )`,
              }}
            ></div>
            <div
              className="preview-3"
              style={{
                backgroundImage: `url(
              ${imgUrlThree}
            )`,
              }}
            ></div>
            <div
              className="preview-4"
              style={{
                backgroundImage: `url(
              ${imgUrlFour}
            )`,
              }}
            ></div>
          </div>
          <div className="label-wrapper">
            <span className="heading-label">
              <span className="icon">
                <CampaignIcon />
              </span>
              <Tooltip placement="top" title={ellipsisState ? heading : undefined}>
                <Paragraph className="paragraph-styling" ellipsis={{ rows: 1, onEllipsis: setEllipsisState }}>
                  <>
                    {heading?.startsWith("[Cloned]") ? (
                      <>
                        {<text style={{ color: "#1EC252" }}>[Cloned]</text>} {heading.substring(8)}
                      </>
                    ) : (
                      heading
                    )}
                  </>
                </Paragraph>
              </Tooltip>
            </span>
            <span className="dec-details">
              <span className="digest-email">{`${emailsCount} email${emailsCount && emailsCount > 1 ? "s" : ""
                }`}</span>
              <span className="date">{published}</span>
            </span>
          </div>
        </div>
        {asset ? (
          <div className="save-and-campaign">
            <span className="save">
              <CampaignIcon /> Save and add to a Campaign…
            </span>
            <div className="actions dot-campaign">
              <ul className="dot-item">
                <li className="card-popover">
                  <ShareMenuPopup>
                    <a>
                      <Elipsis />
                    </a>
                  </ShareMenuPopup>
                </li>
              </ul>
            </div>
          </div>
        ) : (
          <div className="icons-wrapper">
            {/* <span className="theme-data">
              <Theme />
              Theme
            </span> */}
            <div className="actions d-flex justify-content-between">
              <ul>
                <li>
                  <Tooltip placement="top" title="Total Contacts">
                    <a>
                      <Audience />
                      <span className="qa-total-campaignlist">{audience}</span>
                    </a>
                  </Tooltip>
                </li>
                <li>
                  <Tooltip placement="top" title="Emails Sent">
                    <a>
                      <Send />
                      <span>{send}</span>
                    </a>
                  </Tooltip>

                </li>
                <li>
                  <Tooltip placement="top" title="Emails Delivered">
                    <a>
                      <Mail />
                      <span>{mail}</span>
                    </a>
                  </Tooltip>

                </li>
                <li>
                  <Tooltip placement="top" title="Total Opens">
                    <a>
                      <Eye />
                      <span>{views}</span>
                    </a>
                  </Tooltip>

                </li>
                <li>
                  <Tooltip placement="top" title="Total Clicks">
                    <a>
                      <Click />
                      <span>{clicks}</span>
                    </a>
                  </Tooltip>

                </li>
              </ul>
              <ul className="dot-item">
                <li className="card-popover">
                  <MenuPopup
                    cloneCampaignHandler={cloneCampaignHandler}
                    emailsCount={emailsCount}
                    campaignId={campaignId}
                    deleteHandler={deleteHandler}
                    showDeleteConfirmation={showDeleteConfirmation}
                    index={index}
                    disableDelete={automation || sentViaPlugin}
                  >
                    {/* // eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a>
                      <Elipsis />
                    </a>
                  </MenuPopup>
                </li>
              </ul>

            </div>

          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default CampaignList;

const Wrapper = styled.div`
.wf-icon{
  position: absolute;
  right: 10px;
  top: 5px;
  span {
    margin-left: 2px;
  }
}
.styling-tag {
    display: flex;
    align-items: center;
    margin: 0;
    border-radius: 16px;
    color: #27ce0a;
    vertical-align: middle;
    font-size: 12px;
    font-weight: 700;
    font-family: "robotoregular";
    line-height: 16px;
    margin-top: 0px;
    /* margin-right: 5px; */
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 9px;
      line-height: 12px;
      border-radius: 10px;
      /* margin-top: -15px; */
    }
    &.pending-tag {
      background-color: #fff !important;
      color: #27ce0a;
    }
    &.error-tag {
      background-color: #d22121 !important;
      color: #f9f8f6;
    }
    &.automation-icon {
      padding: 3px 6px;
      background-color: #def6e6 !important;
      svg {
        width: 12px;
        height: auto;
        vertical-align: middle;
        g {
          fill: #27ce0a;
        }
      }
    }
  }
  .list-wrapper {
    padding: 15px;
    display: flex;
    align-items: center;
    background-color: #fff;
    justify-content: space-between;
    border-radius: 10px;
    width: auto;
    margin-bottom: 10px;
    cursor: pointer;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 7px;
      padding: 10px;
    }
    &.active {
      border: 2px solid #27ce0a;
    }
    .left-data {
      display: flex;
      align-items: center;
      width: calc(100% - 350px);
    }
    .img-wrapper {
      min-width: 70px;
      height: 70px;
      border-radius: 6px;
      margin-right: 18px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 57px;
        height: 48px;
        border-radius: 4px;
      }
    }
    .preview-1 {
      width: 50%;
      height: 35px;
      border-radius: 6px 0px 0px 0px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      border-bottom: 1px solid #fff;
      border-right: 1px solid #fff;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 25px;
        border-radius: 4px 0px 0px 0px;
      }
    }
    .preview-2 {
      width: 50%;
      height: 35px;
      border-radius: 0px 6px 0px 0px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      border-bottom: 1px solid #fff;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 25px;
        border-radius: 0px 4px 0px 0px;
      }
    }
    .preview-3 {
      width: 50%;
      height: 35px;
      border-radius: 0px 0px 0px 6px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      border-right: 1px solid #fff;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 25px;
        border-radius: 0px 0px 0px 4px;
      }
    }
    .preview-4 {
      width: 50%;
      height: 35px;
      border-radius: 0px 0px 6px 0px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 25px;
        border-radius: 0px 0px 4px 0px;
      }
    }
    .label-wrapper {
      display: block;
      width: 100%;
      .icon {
        margin-top: -2px;
        margin-right: 8px;
        svg {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 13px;
          }
        }
      }
      .heading-label {
        margin-bottom: 8px;
        align-items: center;
        display: flex;
        font-family: "Roboto Slab", serif;
        font-size: 22px;
        color: #424b50;
        font-weight: 900;
        line-height: 28px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 16px;
          line-height: 18px;
          margin-bottom: 0px;
        }
      }
      .paragraph-styling {
        margin-bottom: 0px;
        overflow: hidden;
      }
      .dec-details {
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 9px;
        }
        .digest-email {
          color: #db3725;
          font-family: "robotomedium";
          font-size: 12px;
          font-weight: 600;
          line-height: 15px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 9px;
            line-height: 12px;
          }
        }
        .date {
          color: #7e7e7e;
          font-weight: 600;
          font-size: 12px;
          line-height: 15px;
          padding-left: 5px;
          margin-left: 6px;
          border-left: 2px solid #7e7e7e;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 9px;
          }
        }
      }
    }
    .theme-data {
      color: #ffffff;
      font-size: 14px;
      line-height: 18px;
      font-family: "robotomedium";
      background-color: #27ce0a;
      padding: 3px 10px;
      border-radius: 12px;
      height: 24.5px;
      margin-top: 3px;
      margin-right: 50px;
      svg {
        margin-top: -2px;
        margin-right: 5px;
      }
    }
    .icons-wrapper {
      display: flex;
      align-items: center;
    }
    .actions {
      &.dot-campaign {
        .dot-campaign {
          padding-top: 0px;
        }
      }
      .dot-item {
        margin-left: 60px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-right: 0;
        }
      }
      ul {
        list-style: none;
        margin: 0 -10px;
        padding: 0;
        li {
          float: left;
          display: inline-block;
          padding: 0 3px;
          @media all and (max-width: 1200px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding: 0;
          }
          a {
            padding: 0 5px;
            text-align: center;
            display: block;
            @media all and (max-width: 1300px) {
              padding: 0 3px;
            }
            svg {
              width: 18px;
              max-height: 12px;
              path {
                fill: #000000;
                opacity: 0.5;
              }
              g {
                opacity: 1;
              }
            }
            span {
              color: #5e7079;
              /* opacity: 0.5; */
              font-size: 10px;
              font-family: "helveticaneuebold";
              font-weight: 700;
              display: block;
              text-align: center;
            }
          }
          &.card-popover {
            float: right;
            padding-top: 7px;
            a {
              svg {
                width: 5px;
                max-height: none;
                @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                  width: 3px;
                }
              }
            }
          }
          &:hover {
            a {
              svg path {
                fill: #27ce0a;
                opacity: 1;
              }
            }
          }
        }
      }
    }
    .save-and-campaign {
      display: flex;
      align-items: center;
      cursor: pointer;
      svg {
        margin-right: 9px;
        path {
          fill: #27ce0a;
          stroke: transparent;
        }
      }
      .save {
        color: #27ce0a;
        border: 0;
        font-family: "robotomedium";
        font-size: 14px;
        margin: 0 5px;
        font-weight: 600;
        max-width: calc(100% - 60px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
`;
